import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { jsonOrThrow } from '../apiJson';
import { isPriceCollectionSlug } from '../priceCollections';
import { CategoryPage } from './CategoryPage';
import { PriceCollectionPage } from './PriceCollectionPage';

export function ShopRoute() {
  const { slug: rawSlug } = useParams();
  const slug = (rawSlug ?? '').toLowerCase();
  const [resolved, setResolved] = useState(() =>
    isPriceCollectionSlug(slug) ? 'price' : 'unknown',
  );

  useEffect(() => {
    if (isPriceCollectionSlug(slug)) {
      setResolved('price');
      return undefined;
    }

    let cancelled = false;
    setResolved('unknown');

    fetch('/api/landing-categories.php')
      .then((r) => jsonOrThrow(r))
      .then((data) => {
        if (cancelled) {
          return;
        }
        const categories = Array.isArray(data?.categories) ? data.categories : [];
        const match = categories.find((c) => c.slug === slug) ?? null;
        if (match?.priceCollection === true) {
          setResolved('price');
        } else {
          setResolved('category');
        }
      })
      .catch(() => {
        if (!cancelled) {
          setResolved('category');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (resolved === 'price') {
    return <PriceCollectionPage />;
  }

  if (resolved === 'category') {
    return <CategoryPage />;
  }

  return (
    <div className="results-page category-page">
      <p className="category-page__status" aria-live="polite">
        Loading…
      </p>
    </div>
  );
}
